document.addEventListener('DOMContentLoaded', function() {
  // Alle Dropdown-Elemente im Footer finden
  const dropdowns = document.querySelectorAll('.footer-block__mobile-menu .mobile-dropdown');
  
  // Für jedes Dropdown
  dropdowns.forEach(dropdown => {
    // Das summary-Element finden
    const summary = dropdown.querySelector('summary');
    // Den Inhalt finden
    const content = dropdown.querySelector('.footer-block__details-content');
    
    // Sicherstellen, dass die Animation jedes Mal neu startet
    summary.addEventListener('click', function(event) {
      // Verhindern des Standard-Verhaltens, damit wir es selbst steuern können
      event.preventDefault();
      
      // Animation zurücksetzen, damit sie jedes Mal neu startet
      content.style.animation = 'none';
      
      // Browser zwingen, die Änderung zu registrieren
      void content.offsetWidth;
      
      // Wenn das Dropdown geschlossen ist, öffnen wir es
      if (!dropdown.hasAttribute('open')) {
        dropdown.setAttribute('open', '');
        // Animation beim Öffnen
        content.style.animation = 'slideDown 0.5s ease-out forwards';
      } else {
        // Animation beim Schließen
        content.style.animation = 'slideUp 0.5s ease-in forwards';
        
        // Warten, bis die Animation abgeschlossen ist, bevor wir das Dropdown schließen
        setTimeout(() => {
          dropdown.removeAttribute('open');
        }, 500); // 500ms = Dauer der Animation
      }
    });
  });
});